// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab_tab__1SJ6o","tabHeader":"tab_tabHeader__1I41o"};